import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PreNotaPedidosService {

  constructor(
    private http: HttpClient
  ) { }


  getCompra(cnpj: any) {
    return this.http.get(`${environment.protheus}/compra?cnpj=${cnpj}`);
  }

  getItemCompra(cnpj: any, pedidocompra?: any) {
    return this.http.get(`${environment.protheus}/itemcompra?cnpj=${cnpj}&pedidocompra=${pedidocompra}`);
  }

  salvarPreNota(parameters?: any) {
    return this.http.post(`${environment.protheus}/prenota`, parameters);
  }

  filtrarPreNota(parameters?: any) {
    return this.http.post(`${environment.protheus}/browser`, parameters);
  }

  enviarEmail(values: any) {
    return this.http.post(`${environment.protheus}/prenota/email`, values);
  }
}
